<template>
    <div class="registration">
        <div class="information">
            <div class="columns">
                <div class="column is-narrow">
                    <i class="fad fa-presentation has-text-primary fa-fw fa-2x"></i>
                </div>
                <div class="column">
                    <div class="columns is-block-tablet is-flex-widescreen">
                        <div class="column">
                            <div class="has-text-weight-bold ">{{ registration.conferences.title }}</div>
                            <div class="meta mb-2">{{ registration.conferences.organizations.title }}</div>

                            <div class="meta" v-if="registration.conferences.location"><i class="far fa-fw fa-location-dot mr-2"></i>{{ registration.conferences.location }}</div>
                            <div class="meta"><i class="far fa-fw fa-calendar-week mr-2"></i>{{ confDates }}</div>
                            <div class="is-size-6 mb-2 has-text-grey" v-if="isPreRegistation">
                                <hr/>

                                <div class="columns is-gapless">
                                    <div class="column is-narrow"><i class="far fa-fw fa-info-circle mr-2"></i></div>
                                    <div class="column">
                                        <span class="has-text-weight-bold">You have pre-registered for this conference.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="column has-text-right is-narrow">
                            <router-link :to="'/conference/' + registration.id">
                                <b-button type="is-primary" size="" expanded><i class="fas fa-presentation mr-2"></i>View Conference</b-button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="registration.is_po_pending">
                <div class="is-size-6 mb-1 has-text-grey">
                    <div class="columns">
                        <div class="column is-narrow"><i class="fas fa-fw fa-2x"></i></div>
                        <div class="column">
                            <hr class="mt-0"/>

                            <div class="columns is-gapless">
                                <div class="column is-narrow"><i class="far fa-fw fa-exclamation-triangle has-text-danger mr-2"></i></div>
                                <div class="column" v-if="registration.conferences.is_allow_invoice">
                                    <p><span class="has-text-weight-bold">You opted to use a Purchase Order (P.O.) for your registration.</span> You can generate a P.O. Request which <u>you</u> may need to submit for a purchase order. Carefully follow any instructions on the P.O. request and follow through on this process. Your registration will not be complete until the purchase order process is complete. Please contact the event organizer if you have any questions.</p>
                                    <div class="mt-5 mb-4">
                                        <router-link :to="'/conference/' + registration.id + '/PO'">
                                            <b-button type="is-danger"><i class="far fa-file-invoice mr-2"></i>Generate Request/Invoice</b-button>
                                        </router-link>
                                        <b-button class="ml-3" tag="a" :href="'mailto:' + registration.conferences.po_email + '?subject=' + registration.conferences.title + '/Purchase Order'" v-if="registration.conferences.po_email"><i class="far fa-envelope mr-2"></i>Contact Organizer</b-button>
                                    </div>
                                </div>
                                <div class="column" v-else>
                                    <p><span class="has-text-weight-bold">You opted to use a Purchase Order (P.O.) for your registration.</span> Your registration will not be complete until the purchase order process is complete. Please contact the event organizer if you have any questions.</p>
                                    <div class="mt-5 mb-4" v-if="registration.conferences.support_email">
                                        <b-button tag="a" :href="'mailto:' + registration.conferences.support_email + '?subject=' + registration.conferences.title + '/Purchase Order ' + registration.code"><i class="far fa-envelope mr-2"></i>Contact Organizer</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>


            <b-message type="is-warning" v-if="registration.isIncompleteApps">
                <div class="columns is-gapless">
                    <div class="column is-narrow"><i class="fas fa-exclamation-triangle fa-fw mr-3 has-text-warning"></i></div>
                    <div class="column">
                        <div class="is-size-6 has-text-weight-bold">Incomplete Applications or Forms</div>
                        <div class="is-size-7-mt-3">You have incomplete applications or forms that you may wish to complete.</div>
                    </div>
                </div>
            </b-message>
        </div>


    </div>
</template>

<script>
    import moment from "moment";

    export default {
        name: "Registration",
        props: {
            registration: {
                required: true
            }
        },
        computed: {
            confDates: function() {
                let s = moment(this.registration.conferences.start_at);
                let e = moment(this.registration.conferences.end_at);
                if (s.isSame(e, 'day')) {
                    return s.format('MMMM D, YYYY');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMMM D - ') + e.format('D, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D - ') + e.format('MMM D, YYYY');
                } else {
                    return s.format('MMM D, YYYY - ') + e.format('MMM D, YYYY');
                }
            },
            regDates: function() {
                let s = moment(this.registration.conferences.open_at);
                let e = moment(this.registration.conferences.close_at);
                if (s.isSame(e, 'day')) {
                    return s.format('MMMM D, YYYY');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMMM D - ') + e.format('D, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D - ') + e.format('MMM D, YYYY');
                } else {
                    return s.format('MMM D, YYYY - ') + e.format('MMM D, YYYY');
                }
            },
            isPreRegistation: function() {
                return moment().isBefore(moment(this.registration.conferences.start_at));
            },
        }

    };
</script>

<style lang="scss" scoped>
    .registration {
        background-color: white;
        border-radius: 4px;
        box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.4);

        .information {
            padding: 1.5rem 1.5rem 1.5rem;
        }

        .meta {
            font-size: 0.9rem;
            color: #6e6e6e;
        }
    }
</style>

<style lang="scss">

    .enroll-progress {
        margin-bottom: 0.2rem !important;

        .progress {
            height: 0.25rem !important;
        }
    }
</style>
